export const isAboveDate = (day: number, month: number) => {
  const today = new Date();

  return today.getMonth() > month - 1 || (today.getMonth() === month - 1 && today.getDate() > day);
};
